// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function toString(status) {
  switch (status) {
    case /* Completed */0 :
        return "COMPLETED";
    case /* Pending */1 :
        return "PENDING";
    case /* Failed */2 :
        return "FAILED";
    case /* Held */3 :
        return "HELD";
    
  }
}

function fromString(status) {
  switch (status) {
    case "COMPLETED" :
        return /* Completed */0;
    case "FAILED" :
        return /* Failed */2;
    case "HELD" :
        return /* Held */3;
    case "PENDING" :
        return /* Pending */1;
    default:
      return ErrorUtils$Catalyst.raiseError("WalletTransactionStatus.re", "Invalid wallet status", status);
  }
}

function getWalletStatusList(param) {
  return {
          hd: /* Completed */0,
          tl: {
            hd: /* Pending */1,
            tl: {
              hd: /* Failed */2,
              tl: {
                hd: /* Held */3,
                tl: /* [] */0
              }
            }
          }
        };
}

export {
  toString ,
  fromString ,
  getWalletStatusList ,
  
}
/* No side effect */
